import RejectPartnerForm from './RejectPartnerForm';

export default RejectPartnerForm;
